import { auditActionLabel } from '../../shell/audit-actions';
const RU = {
  'audit.title': 'Журнал',
  'audit.subtitle': 'Кто, когда и что изменил — и лента событий системы',

  'audit.tab.actions': 'Действия',
  'audit.tab.events': 'События',

  'audit.filter.action': 'Действие',
  'audit.filter.entity': 'Тип записи',
  'audit.filter.entityId': 'Идентификатор записи',
  'audit.filter.entityIdHint': 'Скопируйте его из колонки «Запись» — там он рядом с типом.',
  'audit.filter.site': 'Объект',
  'audit.filter.from': 'С',
  'audit.filter.to': 'По',
  'audit.filter.any': 'Любое',
  'audit.filter.anyEntity': 'Любой',
  'audit.filter.anySite': 'Все доступные',
  'audit.filter.reset': 'Сбросить',
  'audit.filter.refresh': 'Обновить',
  'audit.filter.actorOn': 'Только этот сотрудник',
  'audit.filter.actorOff': 'Снять фильтр по сотруднику',
  'audit.filter.count': '{count} за 30 дней',

  'audit.col.when': 'Когда',
  'audit.col.who': 'Кто',
  'audit.col.what': 'Действие',
  'audit.col.entity': 'Запись',
  'audit.col.site': 'Объект',
  'audit.col.changes': 'Изменения',

  'audit.actor.system': 'Система',
  'audit.actor.device': 'Устройство',
  'audit.actor.service': 'Служба',
  'audit.actor.unknown': 'Неизвестно',

  'audit.changes.none': 'без сравнения',
  'audit.changes.created': 'создано',
  'audit.changes.removed': 'удалено',
  'audit.changes.fields': 'полей: {count}',

  'audit.detail.title': 'Запись журнала',
  'audit.detail.before': 'Было',
  'audit.detail.after': 'Стало',
  'audit.detail.request': 'Запрос',
  'audit.detail.ip': 'Адрес',
  'audit.detail.agent': 'Программа',
  'audit.detail.masked':
    'Персональные данные в журнале заменены на [redacted] при записи. Восстановить их из журнала нельзя — так и задумано.',

  'audit.more': 'Показать ещё',
  'audit.empty': 'Записей нет',
  'audit.empty.reason':
    'За выбранный период и по этим фильтрам журнал пуст. Расширьте период или снимите фильтр.',

  'audit.events.col.kind': 'Событие',
  'audit.events.col.entity': 'Запись',
  'audit.events.col.payload': 'Данные',
  'audit.events.empty': 'Событий нет',
  'audit.events.empty.reason':
    'Лента пуста: система ещё не публиковала событий по доступным вам объектам.',
  'audit.events.hint':
    'Лента — то, что модули рассказывают друг другу. Журнал действий отвечает на вопрос «кто это сделал», лента — «что из этого вышло».',

  'audit.trail.title': 'История изменений',
  'audit.trail.empty': 'Изменений не было',
  'audit.trail.all': 'Весь журнал по этой записи',
} as const;

const KK: Record<keyof typeof RU, string> = {
  'audit.title': 'Журнал',
  'audit.subtitle': 'Кім, қашан және нені өзгертті — және жүйе оқиғаларының таспасы',

  'audit.tab.actions': 'Әрекеттер',
  'audit.tab.events': 'Оқиғалар',

  'audit.filter.action': 'Әрекет',
  'audit.filter.entity': 'Жазба түрі',
  'audit.filter.entityId': 'Жазба идентификаторы',
  'audit.filter.entityIdHint': 'Оны «Жазба» бағанынан көшіріңіз — түрінің қасында тұр.',
  'audit.filter.site': 'Нысан',
  'audit.filter.from': 'Бастап',
  'audit.filter.to': 'Дейін',
  'audit.filter.any': 'Кез келген',
  'audit.filter.anyEntity': 'Кез келген',
  'audit.filter.anySite': 'Барлық қолжетімді',
  'audit.filter.reset': 'Тазарту',
  'audit.filter.refresh': 'Жаңарту',
  'audit.filter.actorOn': 'Тек осы қызметкер',
  'audit.filter.actorOff': 'Қызметкер сүзгісін алу',
  'audit.filter.count': '30 күнде {count}',

  'audit.col.when': 'Қашан',
  'audit.col.who': 'Кім',
  'audit.col.what': 'Әрекет',
  'audit.col.entity': 'Жазба',
  'audit.col.site': 'Нысан',
  'audit.col.changes': 'Өзгерістер',

  'audit.actor.system': 'Жүйе',
  'audit.actor.device': 'Құрылғы',
  'audit.actor.service': 'Қызмет',
  'audit.actor.unknown': 'Белгісіз',

  'audit.changes.none': 'салыстыру жоқ',
  'audit.changes.created': 'жасалды',
  'audit.changes.removed': 'жойылды',
  'audit.changes.fields': 'өрістер: {count}',

  'audit.detail.title': 'Журнал жазбасы',
  'audit.detail.before': 'Болды',
  'audit.detail.after': 'Болды (жаңа)',
  'audit.detail.request': 'Сұраныс',
  'audit.detail.ip': 'Мекенжай',
  'audit.detail.agent': 'Бағдарлама',
  'audit.detail.masked':
    'Журналдағы дербес деректер жазу кезінде [redacted] дегенге ауыстырылған. Оларды журналдан қалпына келтіру мүмкін емес — солай жоспарланған.',

  'audit.more': 'Тағы көрсету',
  'audit.empty': 'Жазбалар жоқ',
  'audit.empty.reason':
    'Таңдалған кезең мен сүзгілер бойынша журнал бос. Кезеңді кеңейтіңіз немесе сүзгіні алыңыз.',

  'audit.events.col.kind': 'Оқиға',
  'audit.events.col.entity': 'Жазба',
  'audit.events.col.payload': 'Деректер',
  'audit.events.empty': 'Оқиғалар жоқ',
  'audit.events.empty.reason':
    'Таспа бос: жүйе сізге қолжетімді нысандар бойынша әлі оқиға жарияламаған.',
  'audit.events.hint':
    'Таспа — модульдердің бір-біріне айтқаны. Әрекеттер журналы «мұны кім істеді» дегенге жауап береді, таспа — «одан не шықты».',

  'audit.trail.title': 'Өзгерістер тарихы',
  'audit.trail.empty': 'Өзгерістер болған жоқ',
  'audit.trail.all': 'Осы жазба бойынша толық журнал',
};

export type AuditKey = keyof typeof RU;
export type AuditLocale = 'ru' | 'kk';

const DICTS: Readonly<Record<AuditLocale, Record<AuditKey, string>>> = { ru: RU, kk: KK };

export type AuditTranslate = (key: AuditKey, params?: Record<string, string | number>) => string;

export function makeAuditT(locale: AuditLocale): AuditTranslate {
  const dict = DICTS[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}

/**
 * Человеческое имя действия.
 *
 * Действие пишется строкой вида `loyalty.rule_published`, и таких строк в коде
 * больше двухсот. Заводить словарь на каждую — значит гарантированно отстать от
 * кода: новое действие появится в журнале раньше, чем перевод. Поэтому
 * переводится только префикс — область системы, — а сам глагол показывается как
 * есть. Так строка читается («Лояльность · rule_published»), и ни одно действие
 * не пропадает из-за отсутствия перевода.
 */
const AREAS: Readonly<Record<string, string>> = {
  auth: 'Вход',
  employee: 'Сотрудники',
  customer: 'Клиенты',
  vehicle: 'Автомобили',
  visit: 'Визиты',
  identity: 'Идентификация',
  consent: 'Согласия',
  segment: 'Сегменты',
  loyalty: 'Лояльность',
  subscription: 'Подписка',
  pos: 'Касса',
  shift: 'Смены',
  order: 'Заказы',
  cash: 'Наличные',
  catalog: 'Каталог',
  payment: 'Платежи',
  fiscal: 'Фискализация',
  feedback: 'Обращения',
  comms: 'Коммуникации',
  report: 'Отчёты',
  export: 'Выгрузки',
  bridge: 'Обмен',
  migration: 'Миграция',
  ops: 'Эксплуатация',
  lpr: 'Распознавание',
  tablet: 'Планшет',
  device: 'Устройства',
  site: 'Объекты',
  tariff: 'Тарифы',
};

export function actionArea(action: string): string {
  const prefix = action.split(/[._]/)[0] ?? '';
  return AREAS[prefix] ?? prefix;
}

/**
 * Действие человеческими словами.
 *
 * Раньше здесь просто отрезался префикс, и в колонке оставалось `tier_changed`
 * или `order_refunded` — код на латинице там, где журнал читают при разборе
 * спора «кто и что сделал». Область (`Лояльность`, `Касса`) показывается
 * отдельной строкой ниже и осталась как была.
 */
export function actionVerb(action: string): string {
  const named = auditActionLabel(action);
  if (named !== action) return named;
  const dot = action.indexOf('.');
  return dot === -1 ? action : action.slice(dot + 1);
}
